import { Component,Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-afxexception',
  templateUrl: './afxexception.component.html',
  styleUrls: []
})
export class AfxexceptionComponent implements OnInit {

  
  @Input() dmsLogList;
  @Input() modelHeader;
  @Input() integrationWithDMS;
  environment ;
  logList;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.environment = this.dmsLogList.environment;
    this.logList = this.dmsLogList;
  }

}
